/**
 * Instantly scroll `container` so `element` is vertically centered within it —
 * no smooth animation, so the reposition is imperceptible when done before
 * paint (e.g. in a layout effect).
 */
const scrollElementToCenter = ({
  container,
  element,
}: {
  container: HTMLElement;
  element: HTMLElement;
}): void => {
  const delta =
    element.getBoundingClientRect().top -
    container.getBoundingClientRect().top -
    (container.clientHeight - element.clientHeight) / 2;
  container.scrollTo({ top: container.scrollTop + delta });
};

export default scrollElementToCenter;
